/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import {
  type ProductGranularity,
  ProductGranularitySchema,
} from '../shared/product-granularity'
import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import { type ProductQuery, ProductQuerySchema } from './product-query'

export const RefinedProductsLayout = {
  SLIDER: 'slider',
  GRID: 'grid',
} as const

/* TypeScript */
export type RefinedProductsLayout =
  (typeof RefinedProductsLayout)[keyof typeof RefinedProductsLayout]

export type RefinedProductsApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  subtitle?: Maybe<string>
  ctaLink?: Maybe<CTALink>
  productLayout: RefinedProductsLayout
  productQuery: ProductQuery
  productGranularity?: Maybe<ProductGranularity>
}

/* Schemas */
export const RefinedProductsLayoutSchema = z.enum([
  RefinedProductsLayout.SLIDER,
  RefinedProductsLayout.GRID,
])

export const RefinedProductsApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  ctaLink: z.nullish(CTALinkSchema),
  productLayout: RefinedProductsLayoutSchema,
  productQuery: ProductQuerySchema,
  productGranularity: z.nullish(ProductGranularitySchema),
})

/* Schemas validation */
type TestRefinedProductsApiProps = ExpectTrue<
  Equal<RefinedProductsApiProps, z.infer<typeof RefinedProductsApiPropsSchema>>
>
